
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { RawMaterialClient } from '@/services/Services';
import InfoModal from '@/components/modals/infoModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class MaterialTable extends Vue {

    @Prop() items: OM.RawMaterialConfigurationVM[];
    @Prop() materialType: OM.MaterialType;

    processKeys: string[] = [];

    created() {
        // The server owns the list. Hard-coding "Cemented"/"Vulcanized"/"Injected" here would let the
        // table drift from the validator that enforces them.
        if (this.isProcessBased) {
            RawMaterialClient.getRequiredProcessTypes(this.materialType, false)
            .then(x => {
                this.processKeys = x;
            })
            .catch(y => {
                // processKeys stays [], ready stays false forever, and this tab would otherwise render
                // nothing at all -- no table, no empty-state row, no message. Tell the admin what happened.
                this.$opModal.show(InfoModal, {
                    text: this.$localizationService.getLocalizedValue("Error", "Error"),
                    subtitle: this.$localizationService.getLocalizedValue(
                        "Could not load the emission factor columns for this table.",
                        "Could not load the emission factor columns for this table."),
                    deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                    denyCb: () => {
                        // Unlike editModal.vue's identical catch, there is no outer modal to close here --
                        // this is a page. Dismiss only the InfoModal itself.
                        this.$opModal.closeLast();
                    }
                })
            })
        }
    }

    // MaterialType.Apparel is 0, so `if (this.materialType)` would be false for apparel. Compare explicitly.
    get isProcessBased() {
        return this.materialType == OM.MaterialType.Footwear || this.materialType == OM.MaterialType.Bag;
    }

    get ready() {
        return !this.isProcessBased || this.processKeys.length > 0;
    }

}
